import { ApiError, NetworkError } from "../api/client";
import { MissingTokenError } from "../api/auth";

/** A message worth showing a human, whatever went wrong. */
export function describeError(error: unknown): string {
  if (error instanceof MissingTokenError) {
    return "An API token is required to talk to the server.";
  }
  if (error instanceof NetworkError) {
    return error.message;
  }
  if (error instanceof ApiError) {
    if (error.status === 404) {
      return "Not found.";
    }
    if (error.status === 401 || error.status === 403) {
      return "The server rejected the API token.";
    }
    return error.detail === "" ? `Server error (${error.status}).` : error.detail;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Something went wrong.";
}

/** Aborted in-flight requests are routine (navigation, retyping) — not errors. */
export function isAbort(error: unknown): boolean {
  return error instanceof DOMException && error.name === "AbortError";
}
